import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RemoveDialogContent, RemoveDialogData } from '../models/remove-models';

@Component({
  selector: 'bs-dialog-remove',
  templateUrl: './dialog-remove.component.html',
  styleUrls: ['./dialog-remove.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogRemoveComponent {
  private readonly defaultContent: Required<RemoveDialogContent> = {
    h1: 'Remover produto',
    p: 'Deseja realmente remover o produto?',
    button: 'Remover do carrinho',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: RemoveDialogData | null,
    private readonly dialogRef: MatDialogRef<DialogRemoveComponent>,
  ) {}

  get content(): Required<RemoveDialogContent> {
    return { ...this.defaultContent, ...this.data?.content };
  }

  confirmRemoval(): void {
    this.dialogRef.close(true);
  }
}
